/* eslint-disable no-console */

import { config, DEBUG_LEVEL } from "@/Common/envConfig";
import { isAndroidApp } from "./Ionic";
import { hasValue } from "./Objects";

export const log = (...args: unknown[]) => {
  if ([DEBUG_LEVEL.INFO, DEBUG_LEVEL.WARN, DEBUG_LEVEL.DANGER].includes(config.debugLevel)) {
    console.log("TC_LOG:", ...args.map((arg) => resolveArgument(arg)));
  }
};

export const warm = (...args: unknown[]) => {
  if ([DEBUG_LEVEL.WARN, DEBUG_LEVEL.DANGER].includes(config.debugLevel)) {
    console.warn("TC_WARN:", ...args.map((arg) => resolveArgument(arg)));
  }
};

export const danger = (...args: unknown[]) => {
  if ([DEBUG_LEVEL.DANGER].includes(config.debugLevel)) {
    console.error("TC_ERROR:", ...args.map((arg) => resolveArgument(arg)));
  }
};

export const resolveArgument = (arg: unknown): string | unknown => {
  if (isAndroidApp() && hasValue(arg) && typeof arg === "object") {
    return JSON.stringify(arg);
  }

  return arg;
};
